import { render, staticRenderFns } from "./AdminPlanCreate.vue?vue&type=template&id=06cd6f63"
import script from "./AdminPlanCreate.vue?vue&type=script&lang=js"
export * from "./AdminPlanCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports